import React, { useMemo } from 'react';
import { format } from 'date-fns';
import { CalendarIcon } from 'lucide-react';

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { FormControl } from '@/components/ui/form';
import { cn } from '@/lib/utils';

import { Calendar, CalendarProps } from '@/components/ui/calendar';

type IProps = CalendarProps;

const CalendarInput: React.FC<IProps> = (props) => {
  const label = useMemo(() => {
    if (props.mode === 'range') {
      if (props.selected?.from && props.selected.to) {
        return `${format(props.selected.from, 'PP')} - ${format(props.selected.to, 'PP')}`;
      }
      if (props.selected?.from) {
        return format(props.selected.from, 'PP');
      }
      return 'Escolha a data';
    }

    if (props.mode === 'single') {
      return props.selected ? format(props.selected, 'PP') : 'Escolha a data';
    }

    if (props.mode === 'multiple') {
      return props.selected?.length
        ? `${props.selected.length} selected`
        : 'Escolha a data';
    }

    if (props.mode === 'default') {
      return 'Escolha a data';
    }
  }, [props]);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <FormControl>
          <Button
            variant={'outline'}
            className={cn(
              'w-full pl-3 text-left font-normal',
              !props.selected && 'text-muted-foreground',
            )}
          >
            {label}
            <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
          </Button>
        </FormControl>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar {...props} />
      </PopoverContent>
    </Popover>
  );
};

export default CalendarInput;
